import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";

import SelectUser from "./SelectUser";
import SelectOrderCar from "./SelectOrderCar";

import * as Types from "../commons/typeDTO";

function ModalAddCarOwner({
    open,
    onChangedOpen,
    onAddCarOwner,
}: {
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    onAddCarOwner: (car: Types.CarDto, user: Types.UserDto) => void;
}) {
    const [form] = Form.useForm();

    const [selectedCar, setSelectedCar] = useState<Types.CarDto>();
    const [selectedUser, setSelectedUser] = useState<Types.UserDto>();

    useEffect(() => {
        form.resetFields();
    }, [open]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        onChangedOpen(false);
        if (selectedCar && selectedUser) onAddCarOwner(selectedCar, selectedUser);
    };

    const onChangeOrderCar = (car: Types.CarDto) => {
        setSelectedCar(car);
    };

    const onChangeUser = (user: Types.UserDto) => {
        setSelectedUser(user);
    };

    return (
        <Modal
            centered
            forceRender
            closable={false}
            className="login"
            open={open}
            title="차량 소유자 추가"
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="setPassword" type="primary" onClick={() => form.submit()}>
                    추가
                </Button>,
            ]}
        >
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item name="car" label="차량">
                    <SelectOrderCar onChangeInfo={onChangeOrderCar} />
                </Form.Item>
                <Form.Item name="name" label="사용자">
                    <SelectUser onChangeInfo={onChangeUser} />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ModalAddCarOwner;
